import React, { memo } from 'react';

import PropTypes from 'prop-types';

import localization from '../../../shared/strings';
import DetailsBlock from '../../DetailsBlock';
import ProductHandle from '../ProductHandle';
import { SEO_DESCRIPTION_RECOMMENDED_LENGTH, SEO_TITLE_RECOMMENDED_LENGTH } from '../constants';
import SeoField from './SeoField';

const l10n = localization.PRODUCT_INFO.seo;

const SeoSection = ({
  detailsPanelVisibility,
  toggleVisibility,
  blockName,
  blockTitle,
  handle,
  seoTitle,
  seoDescription,
  fallbackTitle,
  fallbackDescription,
  diff,
  readOnly,
  readOnlyTooltip,
  onChangeHandle,
  onChangeSeoTitle,
  onChangeSeoDescription,
}) => (
  <DetailsBlock
    dataQa="productSeo"
    detailsPanelVisibility={detailsPanelVisibility}
    toggleVisibility={toggleVisibility}
    blockName={blockName}
    blockTitle={blockTitle}
  >
    <ProductHandle
      value={handle}
      readOnly={readOnly}
      readOnlyTooltip={readOnlyTooltip}
      isDiff={diff?.handle}
      onChange={onChangeHandle}
    />
    <SeoField
      label={l10n.seoTitle}
      value={seoTitle}
      readOnly={readOnly}
      readOnlyTooltip={readOnlyTooltip}
      isDiff={diff?.seoTitle}
      recommendedMax={SEO_TITLE_RECOMMENDED_LENGTH}
      field="title"
      fallbackValue={fallbackTitle}
      onChange={onChangeSeoTitle}
    />
    <SeoField
      multiline
      label={l10n.seoDescription}
      value={seoDescription}
      readOnly={readOnly}
      readOnlyTooltip={readOnlyTooltip}
      isDiff={diff?.seoDescription}
      recommendedMax={SEO_DESCRIPTION_RECOMMENDED_LENGTH}
      field="description"
      fallbackValue={fallbackDescription}
      onChange={onChangeSeoDescription}
    />
  </DetailsBlock>
);

SeoSection.propTypes = {
  detailsPanelVisibility: PropTypes.objectOf(PropTypes.bool).isRequired,
  toggleVisibility: PropTypes.func.isRequired,
  blockName: PropTypes.string.isRequired,
  blockTitle: PropTypes.node.isRequired,
  handle: PropTypes.string,
  seoTitle: PropTypes.string,
  seoDescription: PropTypes.string,
  fallbackTitle: PropTypes.string,
  fallbackDescription: PropTypes.string,
  diff: PropTypes.shape({
    handle: PropTypes.bool,
    seoTitle: PropTypes.bool,
    seoDescription: PropTypes.bool,
  }),
  readOnly: PropTypes.bool,
  readOnlyTooltip: PropTypes.string,
  onChangeHandle: PropTypes.func,
  onChangeSeoTitle: PropTypes.func,
  onChangeSeoDescription: PropTypes.func,
};

SeoSection.defaultProps = {
  handle: '',
  seoTitle: '',
  seoDescription: '',
  fallbackTitle: '',
  fallbackDescription: '',
  diff: {},
  readOnly: false,
  readOnlyTooltip: null,
  onChangeHandle: null,
  onChangeSeoTitle: null,
  onChangeSeoDescription: null,
};

export default memo(SeoSection);
